import { combineReducers } from 'redux';
import summary from './checkoutSummaryReducer';
import addressCache from './addressCacheReducer';
import visualState from './checkoutVisualStateReducer';
import loginState from './loginReducer';
import checkoutAsyncStatus from './checkoutAsyncStatusReducer';
import buyNow from './buyNowReducer';
import addressLocation from './addressLocationReducer';
import staticPage from './staticPageReducer';

const checkoutPageReducer = combineReducers({
	summary,
	checkoutAsyncStatus,
	addressCache,
	visualState,
	loginState,
	buyNow,
	addressLocation,
	staticPage
});

export default checkoutPageReducer;
